const isValidDate = function isValidDate(dateString) {
  return dateString && !isNaN(new Date(dateString).getTime())
}

export default isValidDate
